export default "__VITE_ASSET__DR_ngCXG__";